module.exports = __webpack_public_path__ + "media/images/tokihana_career-d046672c2ac951b390fdb36d0ccfd004.svg";